module.exports = __webpack_public_path__ + "img/prize-01.38374361.png";